import React from 'react';

import { Container } from './PastAppointment.styled';
import { Heading } from 'components/v2/Typography/Heading';
import { Appointment } from 'kb-shared';

import { getPastAppointments } from './PastAppointments.utils';
import { List } from '../List/List';

export const PastAppointments = ({ appointments }: { appointments?: Appointment[] }) => {
  const pastAppointments = getPastAppointments(appointments);

  if (pastAppointments.length === 0) return <></>;

  return (
    <Container>
      <Heading tag="div" styledAs="h3">
        Past Appointments
      </Heading>
      <List appointments={pastAppointments} />
    </Container>
  );
};
